import React, { useEffect } from "react";
import { useImmer } from "use-immer";
import { successMessage, errorMessage } from "../../../utils";
import {
  editTemplate,
  getPosSetting,
  updatePosSettings,
} from "../api";
import { useProductSort } from "../../ProductSorting";

export const usePosSettings = ({ isList }) => {
  const { state: stateTemplates } = useProductSort({ isList });
  const [state, setState] = useImmer({
    isSaveButtonBusy: false,
    display_mode: "",
    display_position: "",
    posSettingData: {},
    keypad_id: "",
    wastage_keypad_id: "",
    wastage_display_position: ""
  });
  console.log("sett", state.posSettingData);

  useEffect(() => {
    if (isList) {
      getPosSettingList();
    }
  }, [isList]);

  const getPosSettingList = async () => {
    try {
      setState((draft) => {
        draft.isBusy = true;
      });
      const res = await getPosSetting();
      if (res.success) {
        setState((draft) => {
          draft.isBusy = false;
          draft.display_mode = res.data[0]?.display_mode;
          draft.display_position = res.data[0]?.display_position;
          draft.keypad_id = res.data[0]?.keypad_id;
          draft.posSettingData = res?.data[0];
          draft.wastage_display_position = res?.data[0]?.wastage_display_position
          draft.wastage_keypad_id = res?.data[0]?.wastage_keypad_id
        });
      }
    } catch (err) {
      setState((draft) => {
        draft.isBusy = false;
      });
    }
  };
  const onRadioButtonChange = (value, name) => {
    setState((draft) => {
      draft[name] = value;
      draft.isSaveButtonBusy = false;
    });
  };

  const handleOnChange = (name, value, e) => {
    
    setState((draft) => {
      draft[name] = value.value;
    });
  };

  const onUpdateTemplate = async () => {
    const payload = {
      display_mode: state.display_mode,
      display_position: state.display_position,
      keypad_id: state.keypad_id,
      wastage_keypad_id: state.wastage_keypad_id,
      wastage_display_position: state.wastage_display_position
    };

    try {
      setState((draft) => {
        draft.isSaveButtonBusy = true;
      });
      const res = await updatePosSettings(payload);
      if (res.success) {
        successMessage(res.message);
      } else {
        errorMessage(res.message)
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isSaveButtonBusy = false;
      });
    }
  };
  return {
    state,
    stateTemplates,
    onRadioButtonChange,
    handleOnChange,
    onUpdateTemplate,
  };
};
